/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable react/jsx-closing-bracket-location */
/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable react/jsx-child-element-spacing */
/* eslint-disable max-len */
import { UpdateOutlined, VisibilityOutlined } from '@material-ui/icons';
import * as moment from 'moment';
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import Loader from '../Common/Loader';

import { GetDate, GetUtcDate, checkIfLender } from '../../AppUtil/AppUtil';
import DwollaPlaid from '../Common/DwollaPlaid';
import BaseDetail from './BaseDetail';

import InvitationService from '../../Service/InvitationService';
import LoanService from '../../Service/LoanService';
import RatingsService from '../../Service/RatingsService';
import Session from '../../Service/Session';
import {
	toastError,
	toastInvitationSent,
	toastOnResendLoan,
	toastSuccessResendLoan,
	toastWhenLoanStopOrResume,
	toastWhenPaymentMethodBank,
	toastWhenPaymentMethodCashPastDate,
	viewGuarantorDetails,
	viewUserDetails
} from '../../SweetAlertUtil/util';
import PaymentMethod from '../Common/PaymentMethod';
import ResumePaymentDate from '../Common/ResumePaymentDate';
import TermsAndConditions from '../Profile/TermsAndConditions';
import OthersInfo from './EditUserInfo';
import BuxService from '../../Service/BuxService';

const API_URLS = window.AppConfig.API_URLS;
const LOAN_STATES = window.AppConfig.LOAN_STATES;
const LOAN_TYPES = window.AppConfig.LOAN_TYPES;
const LOAN_MODIFICATION_ACTION = window.AppConfig.LOAN_MODIFICATION_ACTION;
const DISBURSAL_STATUS = window.AppConfig.DISBURSAL_STATUS;
const GUARANTOR_STATE = window.AppConfig.GUARANTOR_STATE;

const WORKFLOWS = {
	SETUP_NEW_LOAN: 1,
	SETUP_EXISTING_LOAN: 2,
	BUY_FOR_SOMETHING_LOAN: 3
};

class Details extends Component {
	constructor(props) {
		super(props);
		this.state = {
			_isLoading: false,
			_isDwollaPlaidScreenOpen: false,
			_headingName: '',
			_fromAddAccount: false,
			_isResumeScreenOpen: false,
			_isTermsAndConditionsOpen: false,
			_isOtherInfoScreenOpen: false,
			_isPaymentMethodScreenOpen: false
		};
	}

	toggleTermsConditionsScreen = () => {
		this.setState({
			_isTermsAndConditionsOpen: !this.state._isTermsAndConditionsOpen
		});
	};

	toggleResumeScreen = () => {
		this.setState({
			_isResumeScreenOpen: !this.state._isResumeScreenOpen
		});
	};

	setDefaultName = () => {
		if (checkIfLender(this.props.currentUserId, this.props.loanObject)) {
			this.setState({
				_headingName: 'label.borrower'
			});
		} else {
			this.setState({
				_headingName: 'label.lender'
			});
		}
	};

	refreshOnBackFromModified = async () => {
		try {
			this.startLoader();
			await this.props.refreshState();
			this.stopLoader();
		} catch (err) {
			console.log(err);
			this.stopLoader();
		}
	};

	handlePaymentMethodCallback = payment => {
		if (payment) {
			if (payment.payment_mode === 'ACH') {
				toastWhenPaymentMethodBank(
					this.props.loanObject.name,
					payment,
					this.acceptLoanRequest,
					this.closePaymentMethodScreen
				);
			} else {
				if (moment(payment.payment_date).diff(moment(), 'day') < 0) {
					toastWhenPaymentMethodCashPastDate(payment, this.acceptLoanRequest, this.closePaymentMethodScreen);
				} else {
					this.acceptLoanRequest(payment);
					this.closePaymentMethodScreen();
				}
			}
		}
	};

	handlePaymentMethodWhenDrafted = payment => {
		if (payment) {
			if (payment.payment_mode === 'ACH') {
				toastWhenPaymentMethodBank(
					this.props.loanObject.name,
					payment,
					this.updateLoanCallbackfromPayment,
					this.closePaymentMethodScreen,
					true
				);
			} else {
				if (moment(payment.payment_date).diff(moment(), 'day') < 0) {
					toastWhenPaymentMethodCashPastDate(
						payment,
						this.updateLoanCallbackfromPayment,
						this.closePaymentMethodScreen
					);
				} else {
					this.updateLoanCallbackfromPayment(payment);
					this.closePaymentMethodScreen();
				}
			}
		}
	};

	updateLoanCallbackfromPayment = async payment => {
		try {
			this.closePaymentMethodScreen();
			this.startLoader();
			const loanObject = this.props.loanObject;

			if (payment) {
				const requestBody = {
					start_date: GetUtcDate(new Date()),
					first_installment_date: GetUtcDate(new Date(loanObject.first_installment_date)),
					no_of_installments: parseInt(loanObject.no_of_installments),
					annual_rate: parseFloat(loanObject.annual_rate),
					emi_amount: parseFloat(loanObject.emi_amount),
					frequency: loanObject.frequency,
					loan_type: loanObject.loan_type,
					principal: parseFloat(loanObject.principal),
					state: loanObject.state,
					reason: loanObject.reason,
					collateral: loanObject.collateral,
					additional_terms: loanObject.additional_terms,
					lender_state: loanObject.lender_state,
					disbursal_mode: payment.payment_mode
				};
				if (payment.payment_mode === 'OFFLINE') {
					requestBody.disbursal_date = GetUtcDate(payment.payment_date);
				}
				await LoanService.updateDraftedLoan(loanObject.id, requestBody);
			}
			const response = await InvitationService.resend(loanObject.id);
			await this.props.refreshState();
			if (response.status) {
				toastInvitationSent(this.props.loanObject);
			} else {
				toastError(response.data);
			}
			this.stopLoader();
		} catch (error) {
			this.stopLoader();
			console.log(error);
		}
	};

	sendInviteToUser = async () => {
		try {
			this.startLoader();

			const response = await InvitationService.resend(this.props.loanObject.id);

			await this.props.refreshState();
			if (response.status) {
				toastInvitationSent(this.props.loanObject);
			} else {
				toastError(response.data);
			}
			this.stopLoader();
		} catch (error) {
			console.log(error);
		}
	};

	acceptLoanRequest = async payment => {
		// NOSONAR
		try {
			this.startLoader();
			const requestBody = {
				action: LOAN_STATES.APPROVE,
				buxAuthorization: `Bearer ${Session.getByKey('BUX_AUTH_TOKEN')}`
			};
			if (payment) {
				requestBody.payment_mode = payment.payment_mode;
				if (payment.payment_mode === 'OFFLINE') {
					requestBody.payment_date = GetUtcDate(payment.payment_date);
				}
			}
			const response = await LoanService.update(`${API_URLS.LOAN}/${this.props.loanObject.id}`, requestBody);
	

			await this.props.refreshState();
			this.stopLoader();
			if (!response.status) {
				if (response.data === "Loan can't be approved") {
					this.toastWhenLoanActionFail();
					this.props.closeLoanDetail();
				} else {
					this.toastErrorNoConfirmation(response.data);
				}
			} else {
				if (payment && moment(payment.payment_date).diff(moment(), 'day') < 0) {
					this.toastOnPastPaymentDate();
				} else {
					this.toastLoanAccepted(this.props.loanObject, payment ? payment.payment_mode : '');
				}
			}
		} catch (err) {
			console.log(err);
			this.stopLoader();
			this.toastSomethingWentWrong();
		}
	};

	handleAcceptLoanRequest = () => {
		const wallet_connected = this.props.currentUser.profile.wallet_connected || false;
		const loan = this.props.loanObject;
		if (!wallet_connected) {
			this.redirectToDwollaPlaid();
			return false;
		}
		if (moment(GetDate(new Date())).diff(GetDate(loan.first_installment_date)) > 0) {
			this.toastErrorNoConfirmation('error_message.loan_expires_please_modify');
			return false;
		}
		if (loan.loan_type === LOAN_TYPES.BORROW && (loan.loan_workflow_id === 1 || loan.loan_workflow_id === 0)) {
			this.openPaymentScreen();
			return false;
		}
		this.acceptLoanRequest();
	};

	rejectLoanRequest = async () => {
		try {
			this.startLoader();
			const requestBody = {
				action: LOAN_STATES.DECLINE
			};
			const response = await LoanService.update(`${API_URLS.LOAN}/${this.props.loanObject.id}`, requestBody);
			await this.props.refreshState();
			this.stopLoader();
			if (!response.status) {
				if (response.data === "Loan can't be decline") {
					this.toastWhenLoanActionFail();
					this.props.closeLoanDetail();
				} else {
					this.toastSomethingWentWrong();
				}
			}
		} catch (err) {
			console.log(err);
			this.stopLoader();
		}
	};

	cancelLoanRequest = async () => {
		try {
			this.startLoader();
			const response = await LoanService.delete(`${API_URLS.LOAN}/${this.props.loanObject.id}`);
			console.log(response);
			if (response.status) {
				this.cancelSuccess();
				this.stopLoader();
				this.props.closeLoanDetail();
			} else {
				this.toastSomethingWentWrong();
				this.stopLoader();
			}
			await this.props.refreshState();
		} catch (err) {
			console.log(err);
			this.stopLoader();
		}
	};

	toastOnStopPayment = () => {
		toastWhenLoanStopOrResume(this.handleResumeOrStopPayment);
	};

	onResendLoan = async data => {
		try {
			this.startLoader();
			const requestBody = {};
			if (this.state._isOtherInfoScreenOpen) {
				requestBody.name = data.name.value;
				requestBody.relationship = data.relationship.value;
				requestBody.loan_id = this.props.loanObject.id;
				if (data.phone.value !== '') {
					requestBody.phone = data.countryCode.value + data.phone.value;
				}
				if (data.emailId.value !== '') {
					requestBody.email = data.emailId.value;
				}
			}
			const response = this.state._isOtherInfoScreenOpen
				? await InvitationService.resendToNewUser(this.props.loanObject.id, requestBody)
				: await InvitationService.resend(this.props.loanObject.id);
			if (data !== null) {
				await this.props.refreshState();
			}
			if (!response.status) {
				toastError(response.data);
			} else {
				if (this.props.loanObject.state !== LOAN_STATES.DRAFTED) {
					toastSuccessResendLoan(this.returnTypeOfLoan(), this.props.loanObject.name);
				}
			}
			this.stopLoader();
		} catch (e) {
			console.log(e);
			this.stopLoader();
		}
	};

	returnTypeOfLoan = () => {
		return checkIfLender(this.props.currentUserId, this.props.loanObject) ? 'offer' : 'request';
	};

	toastOnResendLoan = data => {
		const onBack = this.state._isOtherInfoScreenOpen
			? this.toggleOtherInfo
			: () => {
					/* */
			  };
		const acceptorName = this.state._isOtherInfoScreenOpen ? data.name.value : this.props.loanObject.name;
		const userInfo = this.state._isOtherInfoScreenOpen ? data : null;
		toastOnResendLoan(
			this.returnTypeOfLoan(),
			acceptorName,
			this.onResendLoan,
			onBack,
			userInfo,
			this.props.loanObject.state
		);
	};

	handleResumeOrStopPayment = async date => {
		try {
			this.startLoader();
			let requestBody = {};
			if (this.props.loanObject.state === LOAN_STATES.APPROVE) {
				requestBody = {
					action: LOAN_MODIFICATION_ACTION.STOP_PAYMENTS
				};
			} else if (this.props.loanObject.state === LOAN_STATES.EMI_STOPED) {
				requestBody = {
					action: LOAN_MODIFICATION_ACTION.RESUME_PAYMENTS,
					installment_date: date
				};
			}
			const response = await LoanService.paymentAction(this.props.loanObject.id, requestBody);
			await this.props.refreshState();
			if (response.status) {
				console.log(response.data);
			} else {
				toastError(response.data);
			}
			this.stopLoader();
		} catch (err) {
			console.log(err);
			this.stopLoader();
		}
	};
	// =========== (temporary comment dont remove) ==========================//
	// cancelLoanTranferLender = async () => {
	// 	try {
	// 		this.startLoader();
	// 		const requestBody = {
	// 			action: LOAN_MODIFICATION_ACTION.CANCEL_LOAN_TRANSFER
	// 		};
	// 		const response = await LoanService.paymentAction(this.props.loanObject.id, requestBody);
	// 		await this.props.refreshState();
	// 		if (!response.status) {
	// 			toastError(response.data);
	// 		}
	// 		this.stopLoader();
	// 	} catch (err) {
	// 		console.log(err);
	// 		this.stopLoader();
	// 	}
	// };
	// =========== (temporary comment dont remove) ==========================//

	openUpdateFlow = () => {
		if (this.isInstallmentProcessing()) {
			this.toastErrorNoConfirmation('app_message.can_not_update_balace_emi_process');
			return;
		}
		this.props.openUpdateFlow();
	};

	toastWhenCancelLoan = () => {
		Swal.fire({
			html: `${this.props.t('sweetalert_title.are_you_sure')}<br><strong>${this.props
				.t('sweetalert.text_for_loan_cancel_popup')
				.toUpperCase()}</strong>`,
			icon: 'warning',
			allowHtml: true,
			showCancelButton: true,
			reverseButtons: false,
			confirmButtonColor: '#27B88D',
			confirmButtonText: this.props.t('label.yes').toUpperCase(),
			cancelButtonColor: '#FFFFFF',
			cancelButtonText: this.props.t('label.no').toUpperCase(),
			customClass: 'otp_message_success'

			// customClass: {
			// 	confirmButton: 'circular-button',
			// 	cancelButton: 'circular-button'
			// }
		}).then(result => {
			if (result.value) {
				this.cancelLoanRequest();
			}
		});
	};

	toastSomethingWentWrong = () => {
		Swal.fire({
			title: this.props.t('sweetalert_title.error'),
			text: this.props.t('error_message.something_went_wrong'),
			imageUrl: 'https://cdn-icons-png.flaticon.com/512/5219/5219070.png',
			imageAlt: 'Custom Image',
			// icon: 'error',
			confirmButtonText: this.props.t('buttons.try_again'),
			customClass: 'otp_message_success'
		});
	};

	toastErrorNoConfirmation = errorMsg => {
		Swal.fire({
			title: this.props.t('sweetalert_title.we_are_sorry'),
			text: this.props.t(errorMsg),
			imageUrl: 'https://cdn-icons-png.flaticon.com/512/5219/5219070.png',
			imageAlt: 'Custom Image',
			// icon: 'error',
			customClass: 'otp_message_success'
		});
	};

	cancelSuccess = () => {
		Swal.fire({
			animation: false,
			title: this.props.t('sweetalert_title.success'),
			text: this.props.t('sweetalert_title.you_have_successfully_canceled_the_loan'),
			icon: 'success',
			customClass: 'otp_message_success'
		});
	};

	toastLoanAccepted = (loanObject, paymentMethod) => {
		if (checkIfLender(this.props.currentUserId, loanObject)) {
			let acceptanceMessage = '';
			if (paymentMethod === 'ACH') {
				acceptanceMessage = 'sweetalert.loan_accepted_lender_ach';
			} else {
				acceptanceMessage = 'sweetalert.loan_accepted_lender_offline';
			}
			Swal.fire({
				animation: false,
				title: this.props.t('sweetalert_title.thank_you'),
				text: this.props.t(acceptanceMessage, {
					name: this.props.loanObject.name
				}),
				icon: 'success',
				confirmButtonText: this.props.t('buttons.continue'),
				customClass: 'otp_message_success'
			});
		} else {
			let acceptanceMessage = '';
			if (loanObject.disbursal_mode === 'ACH') {
				acceptanceMessage = 'sweetalert.loan_accepted_borrower_ach';
			} else {
				acceptanceMessage = 'sweetalert.loan_accepted_borrower_offline';
			}
			Swal.fire({
				animation: false,
				title: this.props.t('sweetalert_title.congratulations'),
				text: this.props.t(acceptanceMessage, {
					from: this.props.loanObject.name,
					to: this.props.loanObject.name
				}),
				icon: 'success',
				confirmButtonText: this.props.t('buttons.continue'),
				customClass: 'otp_message_success'
			});
		}
	};

	toastWhenLoanActionFail = () => {
		Swal.fire({
			title: this.props.t('sweetalert_title.error'),
			text: this.props.t('sweetalert.your_loan_has_been_canceled'),
			imageUrl: 'https://cdn-icons-png.flaticon.com/512/5219/5219070.png',
			imageAlt: 'Custom Image',
			// icon: 'error',
			confirmButtonText: this.props.t('buttons.try_again'),
			customClass: 'otp_message_success'
		});
	};

	toastOnPastPaymentDate = () => {
		const acceptanceMessage = this.props.t('sweetalert.loan_modified_lender', {
			name: this.props.loanObject.name
		});
		Swal.fire({
			animation: false,
			title: this.props.t('sweetalert_title.request_submitted'),
			text: acceptanceMessage,
			icon: 'success',
			confirmButtonText: this.props.t('button.continue'),
			customClass: 'otp_message_success'
		});
	};

	openPaymentScreen = () => {
		this.setState({
			_isPaymentMethodScreenOpen: true
		});
	};

	closePaymentMethodScreen = () => {
		this.setState({
			_isPaymentMethodScreenOpen: false
		});
	};

	// =========== (temporary comment dont remove) ==========================//
	// popUpOnCancelLoan = () => {
	// 	popUpOnCancelTranfer('buttons.cancel_loan_transfer', this.cancelLoanTranferLender, '');
	// };
	// =========== (temporary comment dont remove) ==========================//

	genrateButton = (name, action) => {
		const downloadDocumentsBtn = {
			[`${this.props.t('buttons.download_documents')}`]: {
				image: '/images/download-documents.png',
				color: '#76C4EE'
			}
		};
		const updateLoanBalBtn = {
			[`${this.props.t('buttons.skip_or_forgive_payment')}`]: {
				image: '/images/resend-loan.png',
				color: '#76C4EE'
			}
		};
		const modifyLoanTermsBtn = {
			[`${this.props.t('buttons.modify_loan_terms')}`]: {
				image: '/images/resend-loan.png',
				color: '#76C4EE'
			}
		};

		// =========== (temporary comment dont remove) ==========================//

		// const cancelLoanTransferBtn = {
		// 	[`${this.props.t('buttons.cancel_loan_transfer')}`]: {
		// 		image: '/images/cancel-loan.png',
		// 		color: '#FFC63C'
		// 	}
		// };

		//= ==============(end line)===========================//

		const cancelLoanBtn = {
			[`${this.props.t('buttons.cancel_loan')}`]: {
				image: '/images/cancel-loan.png',
				color: '#FFC63C'
			}
		};
		const resendLoanBtn = {
			[`${this.props.t('buttons.resend_loan')}`]: {
				image: '/images/resend-loan.png',
				color: '#76C4EE'
			}
		};
		const stopAllPaymentsBtn = {
			[`${this.props.t('buttons.stop_all_payments')}`]: {
				image: '/images/cancel-loan.png',
				color: '#FFC63C'
			}
		};
		const resumeAllPaymentsBtn = {
			[`${this.props.t('buttons.resume_payments')}`]: {
				image: '/images/resume-all-payments.png',
				color: '#FFC63C'
			}
		};
		const viewAmortizationBtn = {
			[`${this.props.t('buttons.view_amortization_table')}`]: {
				image: '/images/view-amortization.png',
				color: '#27B88D'
			}
		};
		const completeLoanBtn = {
			[`${this.props.t('buttons.complete_your_loan')}`]: {
				image: '/images/resend-loan.png',
				color: '#76C4EE'
			}
		};
		const acceptLoanRequestBtn = {
			[`${this.props.t('buttons.accept_loan_request')}`]: {
				image: '/images/resend-loan.png',
				color: '#76C4EE'
			}
		};
		const rejectLoanRequestBtn = {
			[`${this.props.t('buttons.reject_loan_request')}`]: {
				image: '/images/cancel-loan.png',
				color: '#FFC63C'
			}
		};
		const viewModificationsBtn = {
			[`${this.props.t('buttons.view_modifications')}`]: {
				image: '/images/cancel-loan.png',
				color: '#76C4EE'
			}
		};
		const viewAndApproveModificationsBtn = {
			[`${this.props.t('buttons.view_&_approve_modifications')}`]: {
				image: '/images/cancel-loan.png',
				color: '#76C4EE'
			}
		};

		const buttonDetails = {
			...downloadDocumentsBtn,
			...updateLoanBalBtn,
			...modifyLoanTermsBtn,

			// =========== (temporary comment dont remove) ==========================//
			// ...cancelLoanTransferBtn,
			//= ==============(end line)===========================//
			...cancelLoanBtn,
			...resendLoanBtn,
			...stopAllPaymentsBtn,
			...resumeAllPaymentsBtn,
			...viewAmortizationBtn,
			...completeLoanBtn,
			...acceptLoanRequestBtn,
			...rejectLoanRequestBtn,
			...viewModificationsBtn,
			...viewAndApproveModificationsBtn
		};

		return (
			<>
				<div className="loan-details-header-content" onClick={action}>
					<div
						className="loan-details-btn"
						style={{
							backgroundColor: `${buttonDetails[this.props.t(name)]?.color}`,
							textAlign: 'center'
						}}>
						{this.props.t(name) === `${this.props.t('buttons.skip_or_forgive_payment')}` ||
						this.props.t(name) === `${this.props.t('buttons.modify_loan_terms')}` ? (
							<UpdateOutlined
								style={{
									color: 'FFFFFF',
									fontSize: 40,
									textAlign: 'center',
									marginTop: '20%'
								}}
							/>
						) : this.props.t(name) === `${this.props.t('buttons.view_modifications')}` ||
						  this.props.t(name) === `${this.props.t('buttons.view_&_approve_modifications')}` ? (
							<VisibilityOutlined
								style={{
									color: 'FFFFFF',
									fontSize: 40,
									textAlign: 'center',
									marginTop: '20%'
								}}
							/>
						) : (
							<img src={`${buttonDetails[this.props.t(name)]?.image}`} alt={this.props.t(name)} />
						)}
					</div>
					<p>{this.props.t(name)}</p>
				</div>
			</>
		);
	};

	generateButtonsOnModifiedState = loanObject => {
		const buttons = [];
		const returnModBtn = this.returnModificationButton(loanObject.last_modified_by, this.props.currentUserId);
		const generateBtn = this.genrateButton(returnModBtn, this.props.openSeeModification);
		buttons.push(generateBtn);

		// =========== (temporary comment dont remove) ==========================//

		// if (loanObject.state === LOAN_STATES.POST_MODIFIED && checkIfLender(this.props.currentUserId, loanObject)) {
		// 	buttons.push(this.genrateButton('buttons.cancel_loan_transfer', this.popUpOnCancelLoan));
		// }

		//= ==============(end line)===========================//

		return buttons;
	};

	generateAction = () => {
		// NOSONAR
		const loanObject = this.props.loanObject;
		loanObject.installments.sort((a, b) => {
			if (moment(a.installment_date).diff(moment(b.installment_date), 'days') > 0) {
				return 1;
			} else {
				if (moment(b.installment_date).diff(moment(a.installment_date), 'days') > 0) {
					return -1;
				} else {
					return 0;
				}
			}
		});

		if (loanObject.state === LOAN_STATES.EMI_STOPED) {
			if (loanObject.last_modified_by === this.props.currentUserId) {
				return [this.genrateButton('buttons.resume_payments', this.toggleResumeScreen)];
			}
		}

		if (loanObject.accepted_by === this.props.currentUserId) {
			if (loanObject.state === LOAN_STATES.PENDING) {
				return [
					this.genrateButton('buttons.accept_loan_request', this.handleAcceptLoanRequest),
					this.genrateButton('buttons.reject_loan_request', this.rejectLoanRequest),

					this.genrateButton('buttons.modify_loan_terms', this.props.modifyFlow)
				];
			} else if (loanObject.state === LOAN_STATES.APPROVE) {
				if (loanObject.loan_type === LOAN_TYPES.LEND) {
					return this.getButtonBorrowerApprovedLoan(loanObject);
				} else {
					return this.getBtnLenderApprovedLoan(loanObject);
				}
			} else if (
				loanObject.state === LOAN_STATES.POST_MODIFIED ||
				loanObject.state === LOAN_STATES.PRE_MODIFIED
			) {
				return this.generateButtonsOnModifiedState(loanObject);
			} else if (loanObject.state === LOAN_STATES.COMPLETED) {
				return [this.genrateButton('buttons.download_documents', this.props.openDownloadDocuments)];
			}
		} else {
			if (loanObject.state === LOAN_STATES.PENDING) {
				if (loanObject.accepted_by !== null) {
					return [
						this.genrateButton('buttons.modify_loan_terms', this.props.modifyFlow),

						this.genrateButton('buttons.cancel_loan', this.toastWhenCancelLoan),
						this.genrateButton('buttons.resend_loan', this.toastOnResendLoan)
					];
				} else {
					return [
						this.genrateButton('buttons.cancel_loan', this.toastWhenCancelLoan),
						this.genrateButton('buttons.resend_loan', this.toastOnResendLoan)
					];
				}
			} else if (loanObject.state === LOAN_STATES.DRAFTED) {
				return [
					this.genrateButton('buttons.complete_your_loan', this.onCompleteDraftLoan),
					this.genrateButton('buttons.cancel_loan', this.toastWhenCancelLoan)
				];
			} else if (loanObject.state === LOAN_STATES.APPROVE) {
				if (loanObject.loan_type === LOAN_TYPES.LEND) {
					return this.getBtnLenderApprovedLoan(loanObject);
				} else {
					return this.getButtonBorrowerApprovedLoan(loanObject);
				}
			} else if (
				loanObject.state === LOAN_STATES.PRE_MODIFIED ||
				loanObject.state === LOAN_STATES.POST_MODIFIED
			) {
				return this.generateButtonsOnModifiedState(loanObject);
			} else if (loanObject.state === LOAN_STATES.COMPLETED) {
				return [this.genrateButton('buttons.download_documents', this.props.openDownloadDocuments)];
			}
		}
	};

	isInstallmentProcessing = () => {
		let isInstallmentProcessing = false;
		const loanObject = this.props.loanObject;
		const installments = loanObject.installments;
		installments.forEach(i => {
			if (i.state === 'ACH_PENDING') {
				isInstallmentProcessing = true;
			}
		});

		return isInstallmentProcessing;
	};

	getBtnLenderApprovedLoan = loanObject => {
		const buttons = [];
		buttons.push(this.genrateButton('buttons.download_documents', this.props.openDownloadDocuments));
		buttons.push(this.genrateButton('buttons.skip_or_forgive_payment', this.openUpdateFlow));
		// =========== (temporary comment dont remove) ==========================//

		// buttons.push(this.genrateButton('buttons.cancel_loan_transfer', this.popUpOnCancelLoan));

		// =========== (end of this line) ==========================//

		// if (
		// 	loanObject.installments.length > 0 &&
		// 	loanObject.next_installment === loanObject.installments[0].id &&
		// 	!this.isInstallmentProcessing()
		// ) {
		// 	buttons.push(this.genrateButton('buttons.modify_loan_terms', this.props.modifyFlow));
		// } // remove modification button

		return buttons;
	};

	getButtonBorrowerApprovedLoan = _loanObject => {
		const buttons = [];
		buttons.push(this.genrateButton('buttons.download_documents', this.props.openDownloadDocuments));
		buttons.push(this.genrateButton('buttons.stop_all_payments', this.toastOnStopPayment));

		// buttons.push(this.genrateButton('buttons.modify_loan_terms', this.props.modifyFlow));
		return buttons;
	};

	onCompleteDraftLoan = () => {
		const wallet_connected = this.props.currentUser.profile.wallet_connected || false;
		if (!wallet_connected) {
			this.redirectToDwollaPlaid();
		} else if (
			this.props.loanObject.loan_type === LOAN_TYPES.LEND &&
			this.props.loanObject.loan_workflow_id === WORKFLOWS.SETUP_NEW_LOAN
		) {
			this.openPaymentScreen();
		} else {
			this.sendInviteToUser();
		}
	};

	addBankAccount = () => {
		const wallet_connected = this.props.currentUser.profile.wallet_connected || false;
		this.setState({
			_fromAddAccount: true
		});
		if (!wallet_connected) {
			this.redirectToDwollaPlaid();
		}
	};

	redirectToDwollaPlaid = () => {
		this.setState({
			_isDwollaPlaidScreenOpen: true
		});
	};

	closeDwollaPlaid = () => {
		this.setState({
			_isDwollaPlaidScreenOpen: false
		});
		if (!this.state._fromAddAccount && this.props.loanObject.state === 'PENDING') {
			this.handleAcceptLoanRequest();
		} else if (!this.state._fromAddAccount && this.props.loanObject.state === 'DRAFTED') {
			this.onCompleteDraftLoan();
		}
	};

	onBackDwollaPlaid = () => {
		this.setState({
			_isDwollaPlaidScreenOpen: false
		});
	};

	startLoader = () => {
		this.setState({
			_isLoading: true
		});
	};

	stopLoader = () => {
		this.setState({
			_isLoading: false
		});
	};

	returnModificationButton = (lastModify, currentUser) => {
		if (lastModify === currentUser) {
			return 'buttons.view_modifications';
		} else {
			return 'buttons.view_&_approve_modifications';
		}
	};

	toggleOtherInfo = () => {
		this.setState({
			_isOtherInfoScreenOpen: !this.state._isOtherInfoScreenOpen
		});
	};

	onViewDetails = () => {
		const showEditButton =
			this.props.loanObject.created_by === this.props.currentUserId &&
			(this.props.loanObject.state === LOAN_STATES.PENDING ||
				this.props.loanObject.state === LOAN_STATES.DRAFTED);
		const userInfo =
			this.props.currentUserId === this.props.loanObject.created_by
				? this.props.loanObject.accepted_by_user
				: this.props.loanObject.created_by_user;
		viewUserDetails(userInfo, this.toggleOtherInfo, this.props.loanObject, showEditButton);
	};

	onShowGuarantor = () => {
		const userInfo = this.props.loanObject.guarantor_data;
		viewGuarantorDetails(userInfo, this.props.loanObject);
	};

	refreshToken = async () => {
		await BuxService.buxAuthToken();
	};

	componentDidMount() {
		this.refreshToken();
		this.setDefaultName();
		if (this.props.refreshWhenModifiedClose) {
			this.refreshOnBackFromModified();
		}
		if (this.props.props.match.path === '/amortization-table/:id') {
			this.props.openAmortizationTable();
		} else if (
			this.props.props.match.path === '/modify-loan/:id' &&
			(this.props.loanObject.state === LOAN_STATES.PRE_MODIFIED ||
				this.props.loanObject.state === LOAN_STATES.POST_MODIFIED)
		) {
			this.props.openSeeModification();
		}
	}

	render() {
		if (this.state._isDwollaPlaidScreenOpen) {
			return (
				<DwollaPlaid
					currentUser={this.props.currentUser}
					onBack={this.onBackDwollaPlaid}
					onClose={this.closeDwollaPlaid}
					openScreen={this.props.openScreen}
					setCurrentUser={this.props.setCurrentUser}
					supportedStates={this.props.supportedStates}
				/>
			);
		} else if (this.state._isPaymentMethodScreenOpen) {
			return (
				<PaymentMethod
					handleBack={this.closePaymentMethodScreen}
					handleContinue={
						this.props.loanObject.state === 'DRAFTED'
							? this.handlePaymentMethodWhenDrafted
							: this.handlePaymentMethodCallback
					}
					maxPaymentDate={this.props.loanObject.first_installment_date}
				/>
			);
		} else if (this.state._isResumeScreenOpen) {
			return (
				<ResumePaymentDate
					handleBack={this.toggleResumeScreen}
					handleContinue={this.handleResumeOrStopPayment}
					// maxPaymentDate={this.props.loanObject.first_installment_date} //not included
				/>
			);
		} else if (this.state._isTermsAndConditionsOpen) {
			return (
				<TermsAndConditions
					currentUser={this.props.currentUser.profile}
					handleBack={this.toggleTermsConditionsScreen}
					handleContinue={this.redirectToDwollaPlaid}
				/>
			);
		} else if (this.state._isOtherInfoScreenOpen) {
			return (
				<OthersInfo
					backToDetail={this.toggleOtherInfo}
					currentUser={this.props.currentUser}
					flow={checkIfLender(this.props.currentUserId, this.props.loanObject) ? 'LEND' : 'BORROW'}
					fromDetails
					onSubmitDetail={this.toastOnResendLoan}
					supportedRelationships={this.props.supportedRelationships}
					userDetails={this.props.loanObject}
				/>
			);
		} else {
			return (
				<>
					<BaseDetail
						tableColor={this.props.tableColor}
						_isLoading={this.state._isLoading}
						addBankAccount={this.addBankAccount}
						closeLoanDetail={this.props.closeLoanDetail}
						currentUser={this.props.currentUser}
						generateAction={this.generateAction}
						genrateButton={this.genrateButton}
						hashedSupportedStates={this.props.hashedSupportedStates}
						headingName={this.state._headingName}
						loanObject={this.props.loanObject}
						onClickForName={this.onViewDetails}
						onClickShowGuarator={this.onShowGuarantor}
						openAmortizationTable={this.props.openAmortizationTable}
					/>
					{this.state._isLoading ? <Loader /> : ''}
				</>
			);
		}
	}
}

export default withTranslation()(Details);
